import React, { useContext, useState } from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import RingilSidebar from '@components/ringil3/Sidebar/RingilSidebar';
import { VerticalFieldAndValue } from '@components/ringil3/Containers/VerticalFieldAndValue';
import { ApiContext } from '@api/api';
import { InputText } from 'primereact/inputtext';
import { ColWithGap } from '@components/styles';
import useBEValidation from '@hooks/useBEValidation/useBEValidation';

interface ComponentProps<TFilter> {
  filter: TFilter;
  onSave: () => void;
  saveFilters: (body: {name: string, data: TFilter }, onSuccess: (()=>void), hashAuthentication?: string, callbacks?: any) => void
}

export const useSaveFilterSidebar = <TFilter, >() => {
  const [visible, setVisible] = useState(false);

  const SaveFilterSidebar: React.FC<ComponentProps<TFilter>> = ({ filter, onSave, saveFilters }) => {
    const { tr } = useTranslationLgs();
    const { saveUserSupplierNotificationFilters } = useContext(ApiContext);
    const { BackendValidationComponent, setBeValidationErrors } = useBEValidation();
    const [filterName, setFilterName] = useState('');

    const save = () => {
      console.log('save', filter);
      if (!filterName.trim()) return;

      saveFilters(
        {
          name: filterName,
          data: filter,
        },
        () => {
          setVisible(false);
          onSave();
        },
        null,
        { onValidationFailed: setBeValidationErrors },
      );
    };

    return (
      <>
        <RingilSidebar visible={visible} onBack={() => setVisible(false)} onContinue={save} heading={tr('SaveFilterSidebar.saveFilter', 'Save filter')}>
          <BackendValidationComponent />
          <ColWithGap>
            <VerticalFieldAndValue label={tr('SaveFilterSidebar.filterName', 'Filter name')} labelMode={'normal'} required={true}>
              <InputText
                value={filterName}
                onChange={e => setFilterName(e.target.value)}
                maxLength={15}
                placeholder={tr('SaveFilterSidebar.enterFilterName', 'Enter filter name')}
              />
            </VerticalFieldAndValue>
          </ColWithGap>
        </RingilSidebar>
      </>
    );
  };

  return { SaveFilterSidebar, setVisible, visible };
};
